import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { CREDIT_DEBIT_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const CreditDebitApi = createApi({
  reducerPath: "CreditDebit",
  baseQuery,
  tagTypes: ["CreditDebit"],
  endpoints: (builder) => ({
    getCreditDebit: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: CREDIT_DEBIT_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: CREDIT_DEBIT_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["CreditDebit"],
    }),
    getCreditDebitById: builder.query({
      query: ({ id }) => {
        return {
          url: `${CREDIT_DEBIT_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["CreditDebit"],
    }),
    addCreditDebit: builder.mutation({
      query: (payload) => ({
        url: CREDIT_DEBIT_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["CreditDebit"],
    }),
    updateCreditDebit: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${CREDIT_DEBIT_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["CreditDebit"],
    }),
    deleteCreditDebit: builder.mutation({
      query: (id) => ({
        url: `${CREDIT_DEBIT_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CreditDebit"],
    }),
  }),
});

export const {
  useGetCreditDebitQuery,
  useGetCreditDebitByIdQuery,
  useAddCreditDebitMutation,
  useUpdateCreditDebitMutation,
  useDeleteCreditDebitMutation,
} = CreditDebitApi;

export default CreditDebitApi;
